// 表項目の行編集画面
import React from 'react';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button, TextField } from '@material-ui/core';

import { TableRowType, TableAttribute } from '../redux/cardAttributeDbSlice';
import { deepCopy } from '../general';

const ItemField = styled(TextField)`
  width: 100%;
  margin-bottom: 7px;
`

type EditTableAttributeRowDialogProps = {
  open: boolean
  onClose: () => void
  item: TableAttribute;
  id: string;
  row: TableRowType;
  editTableRow: (id: string, value: TableRowType) => void;
}
const EditTableAttributeRowDialog: React.FC<EditTableAttributeRowDialogProps> = ({open, onClose, item, id, row, editTableRow}) => {
  const columnIds = Object.keys(item.columnNames);
  const names = columnIds.map(id => item.columnNames[id]);
  const newRow = deepCopy(row);

  const editExe = (): void => {
    editTableRow(id, newRow);
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="xs">
      <DialogTitle>選択された行を編集します</DialogTitle>
      <DialogContent>
        { columnIds.map((columnId, ix) =>
          <ItemField variant="outlined" label={names[ix]}
            defaultValue={newRow.values[columnId]}
            onChange={(ev) => newRow.values[columnId] = ev.currentTarget.value} />
        ) }
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="text" color="primary">
          キャンセル
        </Button>
        <Button variant="text" color="primary" onClick={editExe}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditTableAttributeRowDialog;
